module.exports = __webpack_public_path__ + "static/media/owl-white-512.5f54ba4c.png";